import { PureComponent } from 'react';
import Switch from 'react-switch';
// import styles from './Switcher.scss';
import { connect } from 'react-redux';
import { setSwitcher } from '../redux/switcher/switcherActions';
import { ReactComponent as SunIcon } from '../styles/icon/sun.svg';
import { ReactComponent as MoonIcon } from '../styles/icon/moon.svg';
import { showLightMode, showDarkMode } from '../elements/Toasts/toastActions';

const mapStateToProps = (state) => ({
  isSwitcherOpen: state.switcher.isSwitcherOpen,
});

const mapDispatchToProps = {
  setSwitcher,
};

class Switcher extends PureComponent {
  handleChange = () => {
    return (
      this.props.isSwitcherOpen
        ? showLightMode('You have switched to light mode')
        : showDarkMode('You have switched to dark mode'),
      this.props.setSwitcher(!this.props.isSwitcherOpen)
    );
  };

  render() {
    const { handleDiameter, height, width, isSwitcherOpen } = this.props;

    return (
      <label>
        <Switch
          checked={isSwitcherOpen}
          onChange={this.handleChange}
          onColor="#4B4D5B"
          onHandleColor="#823CD7"
          offColor="#D2D3D6"
          offHandleColor="#823CD7"
          handleDiameter={handleDiameter}
          uncheckedIcon={false}
          checkedIcon={false}
          uncheckedHandleIcon={<SunIcon />}
          checkedHandleIcon={<MoonIcon />}
          height={height}
          width={width}
          // className={cn({
          //   [styles['react-switch-red']]: this.props.isSwitcherOpen,
          //   [styles['react-switch-grey']]: !this.props.isSwitcherOpen,
          // })}
        />
      </label>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Switcher);
